<template>
  <div class="body-white">
    <div>
      <img class="image-block" alt="Waiting..." src="../assets/icons/loading.gif" />
      <p>{{$t('authentication.pleaseWait')}}</p>
    </div>
  </div>
</template>

<script>
    import {goToAddin} from '../api/login'
    import Language from '../components/Language.vue'

    export default {
        name: 'Addin',
        components: {Language},
        data() {
            window.Office.onReady(() => {
                setTimeout(() => {
                    goToAddin(Office.context.mailbox.userProfile.emailAddress).then((response) => {
                        window.location.href = response.data;
                    })
                }, 1000)
            })
            return {}
        },
        methods: {}
    }
</script>
